import React from "react";
import Skeleton from "react-loading-skeleton";

const ContentSkelton = () => {
  return (
    <div className="d-flex flex-column gap-2">
      <Skeleton className="form-control" height={30} width={"10%"} />
      <Skeleton className="form-control" height={30} width={"20%"} />
      <Skeleton className="form-control" height={30} width={"30%"} />
      <Skeleton className="form-control" height={30} width={"90%"} />
      <Skeleton className="form-control" height={30} width={"50%"} />
      <Skeleton className="form-control" height={30} width={"60%"} />
      <Skeleton className="form-control" height={30} width={"70%"} />
      <Skeleton className="form-control" height={30} width={"80%"} />
    </div>
  );
};

export default ContentSkelton;
